import { type ExtendedWindow, InitialDataKeys } from "./types";

/**
 * Directory the site was written into, relative to the root of the deployment: empty for the
 * unversioned site, `versions/<ref>` for a version of a `gramax-cli build --versions` build. The
 * site's own tree knows nothing about it — every path in the page data starts with the catalog name,
 * as in the unversioned site — so it is applied only where a path becomes a URL.
 */
export const getVersionPrefix = (): string => (window as ExtendedWindow)[InitialDataKeys.VERSION_PREFIX] ?? "";
